import React from 'react';
import { useSelector } from 'react-redux';
import useConfig from 'hooks/use-config';
import { Box, Flex, Text } from '@spothero/ui';
import { EventListItem, ShowMore } from '../event-empty-state-svg';
import EventEmptyStateSvg from '../event-empty-state-svg/EventEmptyStateSvg';
import { buildSearchUrl } from 'utils/url/search/build-search-url';
import { getRouteParam } from 'utils/url-utils';
export const UpcomingEvents = ({ pageSize, additionalStyle = {}, }) => {
    const { siteUrl } = useConfig();
    const partner = useSelector((state) => state.searchRequest.partner);
    const operator_id = useSelector((state) => state.searchRequest.operator_id || getRouteParam('operator_id') // Route param as a backup
    );
    const mapEventItem = (event, index) => {
        if (event) {
            const { id } = event;
            const eventUrl = buildSearchUrl(siteUrl, {
                kind: 'event',
                id,
                hide_event_modal: true,
                operator_id,
                ...(typeof partner === 'string' && { partner }),
            });
            return (<EventListItem key={id} event={event} eventUrl={eventUrl} index={index}/>);
        }
        return undefined;
    };
    const events = useSelector((state) => state.destination.data.events || []).map(mapEventItem);
    const hasEvents = Boolean(events?.length);
    const eventList = hasEvents ? (<Box marginBottom="7">
            <ShowMore pageSize={pageSize}>{events}</ShowMore>
        </Box>) : null;
    return (
    // below adds scrolling on events, NO INDICATOR currently.  Height assumed bit taller than largest from design system
    <Box overflow="auto" maxHeight={{ desktop: '30rem', base: 'none' }} data-testid="UpcomingEvents" {...additionalStyle} flex="1">
            {hasEvents ? (
        //   Leave space for NotGoingToEvent component at bottom
        <Box className="UpcomingEvents-hasEvents" data-testid="UpcomingEvents-hasEvents">
                    {eventList}
                </Box>) : (<Flex flexDirection="column" justifyContent="center" alignItems="center" minHeight={60} textAlign="center">
                    <EventEmptyStateSvg />
                    <Text marginTop={4} data-testid="event-upcoming-text">
                        There are no upcoming events at this venue. <br />
                        Please try again later.
                    </Text>
                </Flex>)}
        </Box>);
};
